import { Bot, RotateCw } from "lucide-react";
import {
  AI_CHAT_SEND_ERROR_MESSAGE,
  AI_CHAT_SEND_ERROR_TITLE,
} from "../constants";

type Props = {
  onRetry: () => void;
  isRetrying?: boolean;
};

export function AIChatSendError({ onRetry, isRetrying }: Props) {
  return (
    <div className="flex items-start gap-3">
      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary text-white">
        <Bot className="h-4 w-4" aria-hidden />
      </span>
      <div className="flex min-w-0 flex-1 items-center gap-3">
        <div className="min-w-0 flex-1 rounded-xl border border-[#E5E7EB] bg-[#F9FAFB] px-4 py-3 shadow-sm">
          <p className="text-sm font-medium text-[#374151]">
            {AI_CHAT_SEND_ERROR_TITLE}
          </p>
          <p className="mt-1 text-sm leading-6 text-[#6B7280]">
            {AI_CHAT_SEND_ERROR_MESSAGE}
          </p>
          <button
            type="button"
            onClick={onRetry}
            disabled={isRetrying}
            className="mt-3 inline-flex items-center gap-1.5 rounded-md border border-[#E5E7EB] bg-white px-3 py-1.5 text-sm font-medium text-[#374151] shadow-sm hover:bg-white/80 disabled:opacity-50"
          >
            <RotateCw
              className={`h-3.5 w-3.5 ${isRetrying ? "animate-spin" : ""}`}
            />
            Try again
          </button>
        </div>
      </div>
    </div>
  );
}
